import { cloudApiHosts, isCloudDevDeploy } from '../../../../config/cloud-deploy-hosts'

// Environment configuration for ServiceFlow Pro Customer Portal
interface EnvironmentConfig {
  apiBaseUrl: string
  wsBaseUrl: string
  visualizerUrl: string
  environment: string
  isProduction: boolean
  isDevelopment: boolean
}

const getEnvironmentConfig = (): EnvironmentConfig => {
  const isProduction = import.meta.env?.PROD || false
  const isDevelopment = import.meta.env?.DEV || false
  
  // Debug logging
  console.log('🔍 Customer Portal Environment Debug:', {
    PROD: import.meta.env?.PROD,
    DEV: import.meta.env?.DEV,
    MODE: import.meta.env?.MODE,
    hostname: window.location.hostname,
    isProduction,
    isDevelopment
  })
  
  const hosts = cloudApiHosts()
  const isProdHost =
    window.location.hostname === 'customer.serviceflow-pro.com' ||
    window.location.hostname === 'dev-customer.serviceflow-pro.com'

  if (isProduction || isProdHost) {
    console.log(isCloudDevDeploy() || window.location.hostname.startsWith('dev-')
      ? '🚀 Customer Portal using CLOUD DEV configuration'
      : '🚀 Customer Portal using PRODUCTION configuration')
    return {
      apiBaseUrl: `${hosts.api}/api`,
      wsBaseUrl: hosts.api,
      visualizerUrl: hosts.visualizerFrontend,
      environment: isCloudDevDeploy() ? 'cloud-dev' : 'production',
      isProduction: true,
      isDevelopment: false
    }
  }
  
  // Development configuration
  console.log('🛠️ Customer Portal using DEVELOPMENT configuration')
  return {
    apiBaseUrl: '/api', // This gets proxied via Vite
    wsBaseUrl: 'http://localhost:3001',
    visualizerUrl: 'http://localhost:5174',
    environment: 'development',
    isProduction: false,
    isDevelopment: true
  }
}

export const env = getEnvironmentConfig()
export default env
